import React from "react";
import { Swiper as _Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";

const ProductsSkeleton = ({ amount = 4 }) => <div className="flex gap-2 md:gap-7">
	{Array.from(Array(amount).keys()).map((_, i) =>
		<div key={i} role="status" className="w-full animate-pulse">
			<div className="mx-auto bg-gray-100 size-40 md:size-60 dark:bg-gray-200"
			/>
			<span className="sr-only">Loading...</span>
		</div>)}
</div>;

const Swiper = ({ children, showLoader, skeleton: Skeleton, ...other }) => {
	const { isClient } = useSelector(state => state.global);
	if (isClient) return <_Swiper role="region" {...other}>{children}</_Swiper>;
	if (showLoader) {
		if (Skeleton) return <Skeleton />;
		return <ProductsSkeleton />;
	}

	return null;
};

export { Swiper, SwiperSlide };